// Third Party Component
import axiosServices from "@pma/utils/axios"

// Routes
import {
  CLONE_PROJECT_ENDPOINT,
  CREATE_PROJECT_ENDPOINT,
  CREATE_PROJECT_GROUP,
  CREATE_PROJECT_GROUP_ENDPOINT,
  DELETE_PROJECT_GROUP,
  EDIT_PROJECT_BY_CURRENT_USER_ENDPOINT,
  GET_FILES_ENDPOINT,
  GET_PROJECT_GROUP_ENDPOINT,
  PIN_PROJECT_ENDPOINT,
  PROJECT_BY_ID_ENDPOINT,
  PROJECT_DELETE_ENDPOINT,
  PROJECT_REMINDER_SET_ENDPOINT,
  PROJECT_WORK_TYPES_DICTIONARY_ENDPOINT,
  PROJECTS_BY_CURRENT_USER_FILTER,
  PROJECTS_GET_BY_CURRENT_USER_BY_GROUP,
  STATUS_DICTIONARY_ENDPOINT,
  UPDATE_PROJECT_GROUP,
} from "@pma/utils/api-routes"
import { ProjectCustomUpdateInput, SetProjectReminderPayload } from "@pma/types"

// Get Project List Service
export const getProjectListService = async (data: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(PROJECTS_BY_CURRENT_USER_FILTER, data)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

// Unpin Project Service
export const pinOrUnpinProjectService = async (id: number) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(`${PIN_PROJECT_ENDPOINT}/${id}`)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

// Create Project Group Service
export const createProjectGroupService = async (data: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(CREATE_PROJECT_GROUP, data)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

// Update Project Group Service
export const updateProjectGroupService = async (data: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(UPDATE_PROJECT_GROUP, data)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

// Delete Project Group Service
export const deleteProjectGroupService = async (data: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .delete(DELETE_PROJECT_GROUP, { data: data })
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const getSelectedProjectGroupsAndProjectListService = async (data: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(PROJECTS_GET_BY_CURRENT_USER_BY_GROUP, data)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const deleteProjectService = async (projectId: number) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .delete(`${PROJECT_DELETE_ENDPOINT}/${projectId}`)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const cloneProjectService = async (data: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(CLONE_PROJECT_ENDPOINT, data)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const getSingleProjectDetailsService = async (projectId: string) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .get(`${PROJECT_BY_ID_ENDPOINT}/${projectId}`)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const createNewProjectService = async (payload: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(CREATE_PROJECT_ENDPOINT, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const getProjectStatusListService = async (params: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .get(STATUS_DICTIONARY_ENDPOINT, { params })
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const updateProjectDetailsService = async (payload: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(EDIT_PROJECT_BY_CURRENT_USER_ENDPOINT, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const getProjectWorkTypeListService = async (params: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .get(PROJECT_WORK_TYPES_DICTIONARY_ENDPOINT, { params })
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const createNewProjectGroupService = async (payload: any) => {
  const response = await axiosServices.post(CREATE_PROJECT_GROUP_ENDPOINT, payload)
  return response.data
}

export const getProjectGroupService = async (params: any) => {
  const response = await axiosServices.get(GET_PROJECT_GROUP_ENDPOINT, { params })
  return response.data
}

export const setProjectReminderService = async (payload: SetProjectReminderPayload) => {
  const response = await axiosServices.post(PROJECT_REMINDER_SET_ENDPOINT, payload)
  return response.data
}

export const updateProjectCustomDetailsService = async ({
  projectId,
  title,
  value,
  customId,
}: ProjectCustomUpdateInput) => {
  const body: Record<string, unknown> = { project_id: projectId }
  if (customId) body.custom_columns = [{ column_id: customId, value }]
  else body[title] = value

  const response = await axiosServices.post(EDIT_PROJECT_BY_CURRENT_USER_ENDPOINT, body)
  return response.data
}

export const getProjectFileByIdService = async (fileId: string | null | undefined) => {
  const response = await axiosServices.get(`${GET_FILES_ENDPOINT}${fileId}`)
  return response.data
}
